import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import {
  TenantServiceService,
  TokenServiceService,
  V1ClaimTokenResponse,
  V1GetTenantByHostnameResponse,
} from '../interface';
import { Result, ok, err } from '../utils/result';

@Injectable({
  providedIn: 'root',
})
export class ApiSafeService {
  private readonly tenantService = inject(TenantServiceService);
  private readonly tokenService = inject(TokenServiceService);

  async getTenantByHostname(
    hostname: string,
  ): Promise<Result<V1GetTenantByHostnameResponse, Error>> {
    try {
      const data = await firstValueFrom<V1GetTenantByHostnameResponse>(
        this.tenantService.tenantServiceGetTenantByHostname(hostname),
      );
      return ok(data);
    } catch (e: unknown) {
      return err(e instanceof Error ? e : new Error(String(e)));
    }
  }

  async claimToken(tokenString: string): Promise<Result<V1ClaimTokenResponse, Error>> {
    try {
      const data = await firstValueFrom<V1ClaimTokenResponse>(
        this.tokenService.tokenServiceClaimToken(tokenString, {}),
      );
      return ok(data);
    } catch (e: unknown) {
      if (e instanceof HttpErrorResponse) {
        const apiMessage = (e.error as { message?: string })?.message ?? e.message;
        return err(new Error(apiMessage));
      }
      return err(e instanceof Error ? e : new Error(String(e)));
    }
  }
}
